import React from 'react';
import { B1, H1, getTranslatedText } from '@nile/components';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const EmptyDataWrap = styled.div`
  width: 360px;
  margin: 90px auto;
  background: #ffffff;
  box-shadow: 0px 5px 20px 4px rgb(0 0 0 / 10%);
  border-radius: 8px;
  display: flex;
  padding: 10px;
  flex-direction: row;
`;
const EmptyContainer = (props) => {
  const { intl, fullWidth } = props;
  return (
    <div className={`mb25 ${fullWidth ? 'full-width' : ''}`}>
      <div className="fx jctr aend">
        <EmptyDataWrap className="empty-data-container">
          <H1 className="text nodata-text-wrap">
            <B1 className="nodata-text">
              {props.heading
                ? props.heading
                : getTranslatedText(intl, 'common.noDataFound')}
            </B1>
          </H1>
          <div className="nodata-img">
            <img
              className="pt25"
              src={props.notFoundURL}
              alt="Kiwi standing on oval"
              width="150px"
            ></img>
          </div>
        </EmptyDataWrap>
      </div>

      {props.action && <div className="fx jctr p25">{props.action}</div>}
    </div>
  );
};

export default injectIntl(EmptyContainer);
